module.exports = __webpack_public_path__ + "ca36d0849d1ede008bcb27b8ef75b87f.jpg";